/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'

export default {
  show (msg, opt) {
    this.action('show', msg, opt)
  },
  error (msg, opt) {
    this.action('error', msg, opt)
  },
  success (msg, opt) {
    this.action('success', msg, opt)
  },
  info (msg, opt) {
    this.action('info', msg, opt)
  },
  action (cta, msg, opt) {
    opt = {
      theme: 'toasted-primary',
      position: 'top-right',
      duration: 5000,
      ...opt }
    Vue.toasted[cta](msg, opt)
  }
}
